import RestApiModel from "@/api/Model/RestApiModel";

class SyncRole extends RestApiModel {
  static getResourceEndpoint() {
    return '/sync/roles';
  }
}

export default SyncRole;
